/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tsb: NonNullable<unknown>, formStatus: NonNullable<unknown>, acwr: NonNullable<unknown>, risk: NonNullable<unknown> }} Coach_Rationale_BaseInputs */

const en_coach_rationale_base = /** @type {(inputs: Coach_Rationale_BaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`TSB is ${i?.tsb}. Form: ${i?.formStatus}. ACWR ${i?.acwr} (${i?.risk} injury risk).`)
};

const de_coach_rationale_base = /** @type {(inputs: Coach_Rationale_BaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`TSB ist ${i?.tsb}. Form: ${i?.formStatus}. ACWR ${i?.acwr} (${i?.risk} Verletzungsrisiko).`)
};

/**
* | output |
* | --- |
* | "TSB is {tsb}. Form: {formStatus}. ACWR {acwr} ({risk} injury risk)." |
*
* @param {Coach_Rationale_BaseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_rationale_base = /** @type {((inputs: Coach_Rationale_BaseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Rationale_BaseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_rationale_base(inputs)
	return de_coach_rationale_base(inputs)
});